import { FilterValues } from "../Types";
import {
  DebtorARSearchResult,
  DebtorCaseSearchResult,
  DebtorSearchResult,
} from "reducers/GlobalSearch/Types";

/**
 * @function
 * @description Determine if the case under debtor.ar should be included based on the filter criterias
 * @returns the boolean decision if the debtor.ar.case should be included
 */
export const doesDebtorCaseInclude = (
  { isOpen }: DebtorCaseSearchResult,
  { isOpenCase, isCloseCase }: FilterValues
): boolean => (isOpenCase && isOpen) || (isCloseCase && !isOpen);

/**
 * @function
 * @description Determine if the ar under debtor should be included based on the filter criterias
 * @returns the boolean decision if the debtor.ar should be included
 */
export const doesARInclude = (
  { creditorName, creditorNumber, arNo, custId }: DebtorARSearchResult,
  { creditorNameNo, arNo: filterARNo, custId: filterCustId }: FilterValues
): boolean => {
  try {
    return (
      (creditorNameNo
        ? creditorName.toUpperCase().includes(creditorNameNo.toUpperCase()) ||
          creditorNumber.toString().includes(creditorNameNo)
        : true) &&
      (filterARNo ? arNo === +filterARNo : true) &&
      (filterCustId ? custId === custId : true)
    );
  } catch (e) {
    return false;
  }
};

/**
 * @function
 * @description Determine if the debtor object should be included based on the filter criterias
 * @returns the boolean decision if the debtor should be included
 */
export const doesDebtorInclude = (
  { debtorName, debtorEntNo }: DebtorSearchResult,
  { debtorNameNo }: FilterValues
): boolean => {
  try {
    return debtorNameNo
      ? debtorName.toUpperCase().includes(debtorNameNo.toUpperCase()) ||
          debtorEntNo.toString().includes(debtorNameNo)
      : true;
  } catch (e) {
    return false;
  }
};
